export default __webpack_public_path__ + "static/gear-outline-49eb5b2a01fc13e2df96c4770b8ac315.svg";